import { MapPin, Phone, } from 'lucide-react';

const Contact = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="bg-slate-900 text-white py-20 md:py-32" data-testid="contact-hero">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-7xl font-bold tracking-tight uppercase mb-6">Contacto</h1>
          <p className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto">
            Estamos aquí para ayudarte con tu proyecto. Contáctanos y resolveremos todas tus dudas.
          </p>
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-20 md:py-32 bg-white" data-testid="contact-info-section">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Left Column - Contact Details */}
            <div>
              <h2 className="text-4xl md:text-5xl font-bold tracking-tight uppercase text-slate-900 mb-8">Información de Contacto</h2>
              <div className="space-y-8">
                {/* Address */}
                <div className="flex gap-4" data-testid="contact-address">
                  <div className="bg-slate-900 p-3 rounded-sm h-fit">
                    <MapPin className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-slate-900 mb-2">Dirección</h3>
                    <p className="text-base leading-relaxed text-slate-600">
                      Av. Paula Albarracín de Sarmiento 2085<br />
                      Rivadavia, San Juan<br />
                      J5406<br />
                      Argentina
                    </p>
                  </div>
                </div>

                {/* Phone */}
                <div className="flex gap-4" data-testid="contact-phone">
                  <div className="bg-slate-900 p-3 rounded-sm h-fit">
                    <Phone className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-slate-900 mb-2">Teléfono</h3>
                    <p className="text-base leading-relaxed text-slate-600">
                      WhatsApp: +54 9 2644 76-2543<br />
                      Horario: Lunes a Viernes 8:00 - 20:00
                  </p>
                  </div>
                </div>
                {/* Email as Image */}
                <div className="flex gap-4" data-testid="contact-email">
                  <div className="bg-slate-900 p-3 rounded-sm h-fit">
                    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-slate-900 mb-2">Email</h3>
                    <img
                      src="https://dummyimage.com/300x50/0f172a/ffffff&text=@metalbrix2025@gmail.com"
                      alt="Email de contacto"
                      className="mt-2 border border-slate-200 rounded-sm"
                    />
                    {/* <p className="text-sm text-slate-500 mt-2 italic">* La imagen muestra nuestro email para evitar spam</p>*/}
                  </div>
                </div>

              {/* Opening Hours */}
              <div className="mt-12 bg-slate-50 p-8 border-l-4 border-blue-700" data-testid="opening-hours">
                <h3 className="text-xl font-semibold text-slate-900 mb-4">Horarios de Atención</h3>
                <div className="space-y-2 text-base text-slate-600">
                  <div className="flex justify-between">
                    <span className="font-medium">Lunes - Viernes:</span>
                    <span>8:00 - 20:00</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium">Sábados:</span>
                    <span>8:00 - 14:00</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-medium">Domingos:</span>
                    <span>Cerrado</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

            {/* Right Column - Map */}
            <div data-testid="contact-map">
              <h2 className="text-4xl md:text-5xl font-bold tracking-tight uppercase text-slate-900 mb-8">Ubicación</h2>
              <div className="aspect-[4/3] w-full border border-slate-200 rounded-sm overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d345.01813663716723!2d-68.54753794946625!3d-31.555602437615452!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x96814014df506c0f%3A0x36131ebeb74ddd4f!2sAv.%20Paula%20Albarrac%C3%ADn%20de%20Sarmiento%202085%2C%20J5402%20San%20Juan!5e0!3m2!1ses-419!2sar!4v1769383414606!5m2!1ses-419!2sar"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Ubicación de MetalBrix"
                ></iframe>
              </div>
            </div>

        </div>
      </div>
      </section>

      {/* Info Banner */}
      <section className="py-20 md:py-32 bg-slate-900 text-white" data-testid="contact-banner">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight uppercase mb-6">¿Tienes un Proyecto en Mente?</h2>
          <p className="text-lg md:text-xl text-slate-300 mb-8">
            No dudes en contactarnos. Estamos listos para convertir tus ideas en realidad con la mejor calidad y profesionalismo.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:2644762543"
              data-testid="contact-call-button"
              className="bg-white text-slate-900 hover:bg-slate-100 rounded-sm px-8 py-4 font-bold uppercase tracking-wider hover-lift hard-shadow inline-flex items-center justify-center gap-2"
            >
              <Phone className="w-5 h-5" /> Llamar Ahora
            </a>
            <a
              href="https://wa.me/5492644762543"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-button"
              className="bg-green-600 text-white hover:bg-green-700 rounded-sm px-8 py-4 font-bold uppercase tracking-wider hover-lift hard-shadow inline-flex items-center justify-center gap-2"
            >
              <Phone className="w-5 h-5" /> WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;